/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AlterInputs */

const en__field_alter = /** @type {(inputs: _Field_AlterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age`)
};

const de__field_alter = /** @type {(inputs: _Field_AlterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter`)
};

/**
* | output |
* | --- |
* | "Age" |
*
* @param {_Field_AlterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_alter = /** @type {((inputs?: _Field_AlterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AlterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_alter(inputs)
	return de__field_alter(inputs)
});